// import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/styles/theme.min.css";
import "./assets/styles/common.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes";
import { useEffect, useState } from "react";
import {
  startSignalRConnection,
  stopSignalRConnection,
} from "./services/signalRService";
import { Tooltip } from "react-tooltip";
import { NotificationProvider } from "./pages/notification/NotificationProvider";

function App() {
  const [notificationReceived, setNotificationReceived] = useState(null);

  const handleNotification = (notification) => {
    setNotificationReceived(notification);
  };

  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");
  //   if (userId) {
  //     startSignalRConnection(handleNotification);
  //   }

  //   return () => {
  //     stopSignalRConnection();
  //   };
  // }, []);

  return (
    <Router>
      <NotificationProvider>
        <AppRoutes notificationReceived={notificationReceived} />
      </NotificationProvider>
      <ToastContainer autoClose={3000} />
      <Tooltip className="custom-tooltip" id="global-tooltip" place="top" />
    </Router>
  );
}

export default App;
